import { c as _c } from "react/compiler-runtime";
import { Box, Button, Checkbox, Divider, FormControl, FormControlLabel, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { BackupStatus, ConditionOperatorEnum } from '@repo/api-gw-sdk';
import type { Condition } from '@repo/api-gw-sdk';
import { useState, type CSSProperties, type UIEventHandler } from 'react';
import { HelpIcon } from '@/components/shared/helpIcon';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { PropertyType, isValueCondition, type FilterProperty } from '@/types/advanceFilter';
import { backupStatus, controlId, controlLevel, mutedControlId } from './properties';
import { BackupStatusFilterRow, AdditionalStatuses, ViolationsDetectedFilterRow } from '../backupStatus/backupStatusFilterRow';
import { Loader } from '../layout/loading';
import { SearchTextBox } from '../search/searchTextBox';
import { TransactionalTextField } from '../shared/transactionalTextField';
import { Virtuoso } from '../shared/virtuoso';
import { TextDetailsTuple } from '../text/textDetailsTuple';
export interface FilterProps {
  property: FilterProperty;
  conditions: Condition[];
  'data-testid'?: string;
  onChange: (conditions: Condition[]) => void;
  renderDrillDownFilter?: (title: string, subtitle: string, component: (props: {
    filter: Condition;
  }) => React.ReactElement) => void;
}
export const FreeTextFilter = t0 => {
  const $ = _c(35);
  const {
    placeholder,
    property,
    conditions,
    onChange,
    "data-testid": dataTestId,
    showSearchIcon: t1
  } = t0;
  const showSearchIcon = t1 === undefined ? true : t1;
  let T0;
  let T1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== conditions || $[1] !== dataTestId || $[2] !== placeholder || $[3] !== property || $[4] !== showSearchIcon) {
    let t10;
    if ($[15] !== property) {
      t10 = x => isValueCondition(x) && x.property === property.name;
      $[15] = property;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    const condition = conditions.find(t10);
    T1 = FormControl;
    t8 = "outlined";
    t9 = true;
    T0 = TransactionalTextField;
    t2 = showSearchIcon;
    t3 = true;
    t4 = placeholder;
    t5 = true;
    t6 = dataTestId;
    t7 = isValueCondition(condition) && condition?.value?.[0] || "";
    $[0] = conditions;
    $[1] = dataTestId;
    $[2] = placeholder;
    $[3] = property;
    $[4] = showSearchIcon;
    $[5] = T0;
    $[6] = T1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    T0 = $[5];
    T1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t10;
  if ($[17] !== conditions || $[18] !== onChange || $[19] !== property) {
    t10 = value => {
      const cleanValue = (value || "").trim();
      onChange(conditions.filter(x_0 => isValueCondition(x_0) && x_0.property !== property.name).concat(cleanValue ? [{
        property: property.name,
        operator: ConditionOperatorEnum.Contains,
        value: [cleanValue]
      }] : []));
    };
    $[17] = conditions;
    $[18] = onChange;
    $[19] = property;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== T0 || $[22] !== t10 || $[23] !== t2 || $[24] !== t3 || $[25] !== t4 || $[26] !== t5 || $[27] !== t6 || $[28] !== t7) {
    t11 = <T0 showSearchIcon={t2} showClearIcon={t3} placeholder={t4} allowEmptyValue={t5} data-testid={t6} initValue={t7} onChange={t10} />;
    $[21] = T0;
    $[22] = t10;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== T1 || $[31] !== t11 || $[32] !== t8 || $[33] !== t9) {
    t12 = <T1 variant={t8} fullWidth={t9}>{t11}</T1>;
    $[30] = T1;
    $[31] = t11;
    $[32] = t8;
    $[33] = t9;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
};
interface OptionType {
  id: string;
  name?: string;
  Image?: React.ReactNode;
  description?: React.ReactNode;
  isGroupTitle?: boolean;
  hideName?: boolean;
}
export const MultiSelectFilter = t0 => {
  const $ = _c(32);
  const {
    property,
    conditions,
    onChange,
    options,
    "data-testid": dataTestId,
    showSelectAll,
    virtuosoStyles,
    onVirtuosoScroll,
    showNameFirst,
    shouldShowId
  } = t0;
  let allOptions;
  let onItemChange;
  let selectedResources;
  let t1;
  if ($[0] !== conditions || $[1] !== dataTestId || $[2] !== onChange || $[3] !== options || $[4] !== property || $[5] !== shouldShowId || $[6] !== showNameFirst || $[7] !== showSelectAll) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t2;
      if ($[12] !== property) {
        t2 = x => isValueCondition(x) && x.property === property.name;
        $[12] = property;
        $[13] = t2;
      } else {
        t2 = $[13];
      }
      const condition = conditions.find(t2);
      selectedResources = isValueCondition(condition) && condition?.value || [];
      onItemChange = (option, newValue) => {
        const values = newValue ? [...selectedResources, option.id] : selectedResources.filter(x_0 => x_0 !== option.id);
        const existingCondition = conditions.find(x_1 => isValueCondition(x_1) && x_1.property === property.name);
        onChange(conditions.filter(x_2 => x_2 !== existingCondition).concat(values.length ? [{
          property: property.name,
          operator: existingCondition ? existingCondition.operator : property.type === PropertyType.MultipleValues ? ConditionOperatorEnum.ContainsAnyOf : ConditionOperatorEnum.In,
          value: values
        }] : []));
      };
      allOptions = showSelectAll ? [{
        id: "select-all"
      }, ...options] : options;
      if (allOptions.length < 100) {
        let t3;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = {
            gap: "4px"
          };
          $[14] = t3;
        } else {
          t3 = $[14];
        }
        t1 = <Stack sx={t3}>{allOptions.map(option_0 => option_0.id === "select-all" ? <SelectAllFilterItem key={option_0.id} options={options} selectedResources={selectedResources} onChange={onChange} conditions={conditions} property={property} /> : <MultiSelectFilterItem key={option_0.id} option={option_0} dataTestId={dataTestId} onChange={newValue_0 => onItemChange(option_0, newValue_0)} isChecked={selectedResources.includes(option_0.id)} shouldShowId={!!shouldShowId} showNameFirst={!!showNameFirst} />)}</Stack>;
        break bb0;
      }
    }
    $[0] = conditions;
    $[1] = dataTestId;
    $[2] = onChange;
    $[3] = options;
    $[4] = property;
    $[5] = shouldShowId;
    $[6] = showNameFirst;
    $[7] = showSelectAll;
    $[8] = allOptions;
    $[9] = onItemChange;
    $[10] = selectedResources;
    $[11] = t1;
  } else {
    allOptions = $[8];
    onItemChange = $[9];
    selectedResources = $[10];
    t1 = $[11];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  let t2;
  if ($[15] !== virtuosoStyles) {
    t2 = virtuosoStyles || {
      height: "100%"
    };
    $[15] = virtuosoStyles;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] !== conditions || $[18] !== dataTestId || $[19] !== onChange || $[20] !== onItemChange || $[21] !== options || $[22] !== property || $[23] !== selectedResources || $[24] !== shouldShowId || $[25] !== showNameFirst) {
    t3 = (index, option_1) => option_1.id === "select-all" ? <SelectAllFilterItem key={option_1.id} options={options} selectedResources={selectedResources} onChange={onChange} conditions={conditions} property={property} /> : <MultiSelectFilterItem key={option_1.id} option={option_1} dataTestId={dataTestId} onChange={newValue_1 => onItemChange(option_1, newValue_1)} isChecked={selectedResources.includes(option_1.id)} shouldShowId={!!shouldShowId} showNameFirst={!!showNameFirst} />;
    $[17] = conditions;
    $[18] = dataTestId;
    $[19] = onChange;
    $[20] = onItemChange;
    $[21] = options;
    $[22] = property;
    $[23] = selectedResources;
    $[24] = shouldShowId;
    $[25] = showNameFirst;
    $[26] = t3;
  } else {
    t3 = $[26];
  }
  let t4;
  if ($[27] !== allOptions || $[28] !== onVirtuosoScroll || $[29] !== t2 || $[30] !== t3) {
    t4 = <Virtuoso style={t2} data={allOptions} onScroll={onVirtuosoScroll} itemContent={t3} />;
    $[27] = allOptions;
    $[28] = onVirtuosoScroll;
    $[29] = t2;
    $[30] = t3;
    $[31] = t4;
  } else {
    t4 = $[31];
  }
  return t4;
};
const SelectAllFilterItem = t0 => {
  const $ = _c(18);
  const {
    options,
    selectedResources,
    onChange,
    conditions,
    property
  } = t0;
  let t1;
  if ($[0] !== options) {
    t1 = options.filter(_temp);
    $[0] = options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectableOptions = t1;
  const t2 = `Select all (${selectableOptions.length})`;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      id: "select-all",
      name: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== conditions || $[5] !== onChange || $[6] !== property || $[7] !== selectableOptions) {
    t4 = newValue => {
      const values = newValue ? selectableOptions.map(_temp2) : [];
      onChange(conditions.filter(x_1 => isValueCondition(x_1) && x_1.property !== property.name).concat(values.length ? [{
        property: property.name,
        operator: property.type === PropertyType.MultipleValues ? ConditionOperatorEnum.ContainsAnyOf : ConditionOperatorEnum.In,
        value: values
      }] : []));
    };
    $[4] = conditions;
    $[5] = onChange;
    $[6] = property;
    $[7] = selectableOptions;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== options || $[10] !== selectedResources) {
    let t6;
    if ($[12] !== selectedResources) {
      t6 = x_2 => selectedResources.includes(x_2.id);
      $[12] = selectedResources;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    t5 = options.every(t6);
    $[9] = options;
    $[10] = selectedResources;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = <MultiSelectFilterItem shouldShowId={false} showNameFirst={false} option={t3} onChange={t4} isChecked={t5} />;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
const MultiSelectFilterItem = t0 => {
  const $ = _c(31);
  const {
    option,
    dataTestId,
    onChange,
    isChecked,
    shouldShowId,
    showNameFirst
  } = t0;
  if (option.isGroupTitle) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        paddingY: "8px"
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== option.name) {
      t2 = <Typography variant="overline" sx={t1}>{option.name}</Typography>;
      $[1] = option.name;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      display: "flex",
      width: "100%"
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = `${dataTestId ? `${dataTestId}-` : ""}${option.id}`;
  let t3;
  if ($[4] !== t2) {
    t3 = {
      "data-testid": t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = t3 as Record<string, string>;
  let t5;
  if ($[6] !== t4) {
    t5 = {
      input: t4
    };
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onChange) {
    t6 = (event, value) => onChange(value);
    $[8] = onChange;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isChecked || $[11] !== t5 || $[12] !== t6) {
    t7 = <Checkbox slotProps={t5} className="p-[8px] mr-[4px]" size="small" checked={isChecked} onChange={t6} />;
    $[10] = isChecked;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      alignItems: "center",
      gap: "12px"
    };
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== option.hideName || $[16] !== option.id || $[17] !== option.name || $[18] !== shouldShowId || $[19] !== showNameFirst) {
    t9 = !option.hideName && <TextDetailsTuple primaryProp={shouldShowId ? showNameFirst ? option.name : option.id : undefined} secondaryProp={showNameFirst ? option.id : option.name} />;
    $[15] = option.hideName;
    $[16] = option.id;
    $[17] = option.name;
    $[18] = shouldShowId;
    $[19] = showNameFirst;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== option.description) {
    t10 = option.description && <HelpIcon title={option.description} className="absolute right-0 cursor-default" tooltipProps={{
      slotProps: {
        tooltip: {
          sx: {
            padding: "16px"
          }
        }
      }
    }} />;
    $[21] = option.description;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== option.Image || $[24] !== t10 || $[25] !== t9) {
    t11 = <Stack direction="row" className="w-[216px] relative" sx={t8}>{option.Image}{t9}{t10}</Stack>;
    $[23] = option.Image;
    $[24] = t10;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== option.id || $[28] !== t11 || $[29] !== t7) {
    t12 = <FormControlLabel key={option.id} className="group/help" sx={t1} control={t7} label={t11} />;
    $[27] = option.id;
    $[28] = t11;
    $[29] = t7;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
};
export const BackupStatusFilter = t0 => {
  const $ = _c(58);
  const {
    conditions,
    onChange,
    renderDrillDownFilter,
    showAdditionalStatuses
  } = t0;
  const {
    dlsgFrontend
  } = useFeatureFlags();
  if (!renderDrillDownFilter) {
    return null;
  }
  let T0;
  let excludedBackupStatusCondition;
  let includedBackupStatusCondition;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let valueConditions;
  if ($[0] !== conditions || $[1] !== dlsgFrontend || $[2] !== onChange || $[3] !== renderDrillDownFilter) {
    valueConditions = conditions.filter(isValueCondition);
    const backupStatusConditions = valueConditions.filter(_temp3);
    includedBackupStatusCondition = backupStatusConditions.find(_temp4);
    excludedBackupStatusCondition = backupStatusConditions.find(_temp5);
    const controlLevelCondition = valueConditions.find(_temp6);
    const selectedStatuses = includedBackupStatusCondition?.value || [];
    const selectedLevel = controlLevelCondition?.value?.[0] || undefined;
    const toggleBackupStatus = status => {
      const cleanConditions = valueConditions.filter(x_3 => x_3 !== includedBackupStatusCondition && x_3.property !== controlLevel.name && x_3.property !== controlId.name && x_3.property !== mutedControlId.name);
      if (selectedStatuses.includes(status)) {
        const updatedStatuses = selectedStatuses.filter(x_4 => x_4 !== status);
        onChange(cleanConditions.concat(updatedStatuses.length === 0 ? [] : [{
          property: backupStatus.name,
          operator: ConditionOperatorEnum.In,
          value: updatedStatuses
        }]));
      } else {
        onChange(cleanConditions.concat({
          property: backupStatus.name,
          operator: ConditionOperatorEnum.In,
          value: selectedStatuses.concat([status])
        }));
      }
    };
    const selectControlLevel = severity => {
      const cleanConditions_0 = valueConditions.filter(x_5 => x_5 !== includedBackupStatusCondition && x_5.property !== controlLevel.name && x_5.property !== controlId.name && x_5.property !== mutedControlId.name);
      onChange(cleanConditions_0.concat({
        property: controlLevel.name,
        operator: ConditionOperatorEnum.Equals,
        value: [severity.toUpperCase()]
      }));
    };
    T0 = Stack;
    t1 = <BackupStatusFilterRow backupStatus={BackupStatus.Protected} toggleBackupStatus={toggleBackupStatus} selectedBackupStatuses={selectedStatuses} />;
    t2 = dlsgFrontend && <BackupStatusFilterRow backupStatus={BackupStatus.Dlsg} toggleBackupStatus={toggleBackupStatus} selectedBackupStatuses={selectedStatuses} />;
    if ($[22] !== selectedStatuses || $[23] !== toggleBackupStatus) {
      t3 = <BackupStatusFilterRow backupStatus={BackupStatus.AllViolationsMuted} toggleBackupStatus={toggleBackupStatus} selectedBackupStatuses={selectedStatuses} />;
      $[22] = selectedStatuses;
      $[23] = toggleBackupStatus;
      $[24] = t3;
    } else {
      t3 = $[24];
    }
    t4 = <ViolationsDetectedFilterRow backupStatus={BackupStatus.ViolationsDetected} toggleBackupStatus={toggleBackupStatus} selectControlLevel={selectControlLevel} selectedBackupStatuses={selectedStatuses} selectedLevel={selectedLevel?.toLowerCase()} renderDrillDownFilter={renderDrillDownFilter} conditions={conditions} onFilterChange={onChange} />;
    if ($[25] !== selectedStatuses || $[26] !== toggleBackupStatus) {
      t5 = <BackupStatusFilterRow backupStatus={BackupStatus.ActionRequired} toggleBackupStatus={toggleBackupStatus} selectedBackupStatuses={selectedStatuses} />;
      $[25] = selectedStatuses;
      $[26] = toggleBackupStatus;
      $[27] = t5;
    } else {
      t5 = $[27];
    }
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Divider sx={{
        margin: "12px -24px"
      }} />;
      $[28] = t6;
    } else {
      t6 = $[28];
    }
    if ($[29] !== selectedStatuses || $[30] !== toggleBackupStatus) {
      t7 = <BackupStatusFilterRow backupStatus={BackupStatus.GenericBackups} toggleBackupStatus={toggleBackupStatus} selectedBackupStatuses={selectedStatuses} />;
      t8 = <BackupStatusFilterRow backupStatus={BackupStatus.NotBackedUp} toggleBackupStatus={toggleBackupStatus} selectedBackupStatuses={selectedStatuses} />;
      t9 = <BackupStatusFilterRow backupStatus={BackupStatus.InitialClassification} toggleBackupStatus={toggleBackupStatus} selectedBackupStatuses={selectedStatuses} />;
      t10 = <BackupStatusFilterRow backupStatus={BackupStatus.Terminated} toggleBackupStatus={toggleBackupStatus} selectedBackupStatuses={selectedStatuses} />;
      $[29] = selectedStatuses;
      $[30] = toggleBackupStatus;
      $[31] = t10;
      $[32] = t7;
      $[33] = t8;
      $[34] = t9;
    } else {
      t10 = $[31];
      t7 = $[32];
      t8 = $[33];
      t9 = $[34];
    }
    t11 = !excludedBackupStatusCondition?.value?.includes(BackupStatus.Disconnected) && <BackupStatusFilterRow backupStatus={BackupStatus.Disconnected} toggleBackupStatus={toggleBackupStatus} selectedBackupStatuses={selectedStatuses} />;
    t12 = !excludedBackupStatusCondition?.value?.includes(BackupStatus.ExcludedFromBackup) && <BackupStatusFilterRow backupStatus={BackupStatus.ExcludedFromBackup} toggleBackupStatus={toggleBackupStatus} selectedBackupStatuses={selectedStatuses} />;
    t13 = !excludedBackupStatusCondition?.value?.includes(BackupStatus.Unsupported) && <BackupStatusFilterRow backupStatus={BackupStatus.Unsupported} toggleBackupStatus={toggleBackupStatus} selectedBackupStatuses={selectedStatuses} />;
    t14 = !excludedBackupStatusCondition?.value?.includes(BackupStatus.LimitExceeded) && <BackupStatusFilterRow backupStatus={BackupStatus.LimitExceeded} toggleBackupStatus={toggleBackupStatus} selectedBackupStatuses={selectedStatuses} />;
    $[0] = conditions;
    $[1] = dlsgFrontend;
    $[2] = onChange;
    $[3] = renderDrillDownFilter;
    $[4] = T0;
    $[5] = excludedBackupStatusCondition;
    $[6] = includedBackupStatusCondition;
    $[7] = t1;
    $[8] = t10;
    $[9] = t11;
    $[10] = t12;
    $[11] = t13;
    $[12] = t14;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = valueConditions;
  } else {
    T0 = $[4];
    excludedBackupStatusCondition = $[5];
    includedBackupStatusCondition = $[6];
    t1 = $[7];
    t10 = $[8];
    t11 = $[9];
    t12 = $[10];
    t13 = $[11];
    t14 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
    valueConditions = $[21];
  }
  let t15;
  if ($[35] !== excludedBackupStatusCondition || $[36] !== includedBackupStatusCondition || $[37] !== onChange || $[38] !== showAdditionalStatuses || $[39] !== valueConditions) {
    t15 = showAdditionalStatuses && <><Divider sx={{
        margin: "12px -24px"
      }} /><AdditionalStatuses valueConditions={valueConditions} onChange={onChange} excludedBackupStatusCondition={excludedBackupStatusCondition} includedBackupStatusCondition={includedBackupStatusCondition} /></>;
    $[35] = excludedBackupStatusCondition;
    $[36] = includedBackupStatusCondition;
    $[37] = onChange;
    $[38] = showAdditionalStatuses;
    $[39] = valueConditions;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== T0 || $[42] !== t1 || $[43] !== t10 || $[44] !== t11 || $[45] !== t12 || $[46] !== t13 || $[47] !== t14 || $[48] !== t15 || $[49] !== t2 || $[50] !== t3 || $[51] !== t4 || $[52] !== t5 || $[53] !== t6 || $[54] !== t7 || $[55] !== t8 || $[56] !== t9) {
    t16 = <T0>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}</T0>;
    $[41] = T0;
    $[42] = t1;
    $[43] = t10;
    $[44] = t11;
    $[45] = t12;
    $[46] = t13;
    $[47] = t14;
    $[48] = t15;
    $[49] = t2;
    $[50] = t3;
    $[51] = t4;
    $[52] = t5;
    $[53] = t6;
    $[54] = t7;
    $[55] = t8;
    $[56] = t9;
    $[57] = t16;
  } else {
    t16 = $[57];
  }
  return t16;
};
export const FullPanelMultiSelectFilter = props => {
  const $ = _c(42);
  const [filter, setFilter] = useState("");
  const [isScrolledVertically, setScrolledVertically] = useState(false);
  if (props.isLoading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Loader />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let condition;
  let t0;
  if ($[1] !== props.conditions || $[2] !== props.property) {
    let t1;
    if ($[5] !== props.property) {
      t1 = x => isValueCondition(x) && x.property === props.property.name;
      $[5] = props.property;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    condition = props.conditions.find(t1);
    t0 = isValueCondition(condition) && condition?.value || [];
    $[1] = props.conditions;
    $[2] = props.property;
    $[3] = condition;
    $[4] = t0;
  } else {
    condition = $[3];
    t0 = $[4];
  }
  const selectedResources = t0;
  let filteredOptions;
  let t1;
  if ($[7] !== filter || $[8] !== props.options || $[9] !== props.shouldShowId) {
    let t2;
    if ($[12] !== filter || $[13] !== props.shouldShowId) {
      t2 = x_0 => !filter || x_0.name?.toLowerCase().includes(filter.toLowerCase()) || props.shouldShowId && x_0.id?.toLowerCase().includes(filter.toLowerCase());
      $[12] = filter;
      $[13] = props.shouldShowId;
      $[14] = t2;
    } else {
      t2 = $[14];
    }
    filteredOptions = props.options.filter(t2);
    t1 = filteredOptions.filter(_temp7);
    $[7] = filter;
    $[8] = props.options;
    $[9] = props.shouldShowId;
    $[10] = filteredOptions;
    $[11] = t1;
  } else {
    filteredOptions = $[10];
    t1 = $[11];
  }
  const filteredOptionsCount = t1.length;
  let t2;
  if ($[15] !== isScrolledVertically) {
    t2 = event => {
      const target = event.target as HTMLDivElement;
      if (typeof target.scrollTop === "number") {
        const isScrolled = target.scrollTop > 0;
        if (isScrolled !== isScrolledVertically) {
          setScrolledVertically(isScrolled);
        }
      }
    };
    $[15] = isScrolledVertically;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  const onScroll = t2;
  let t3;
  if ($[17] !== filter || $[18] !== isScrolledVertically || $[19] !== props.hideSearch) {
    t3 = !props.hideSearch && <Stack className="px-[24px] pb-[24px]" sx={{
      borderBottom: "1px solid var(--mui-palette-divider)",
      boxShadow: isScrolledVertically ? "var(--mui-customShadows-panel)" : undefined
    }}><SearchTextBox value={filter} onChange={setFilter} placeholder="Search by name or ID" /></Stack>;
    $[17] = filter;
    $[18] = isScrolledVertically;
    $[19] = props.hideSearch;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      flexGrow: 1
    };
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== filteredOptionsCount) {
    t5 = filteredOptionsCount === 0 && <Typography variant="body1" className="my-[12px]">{"No matching values found. Try a new search term."}</Typography>;
    $[22] = filteredOptionsCount;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] !== filter || $[25] !== filteredOptions || $[26] !== filteredOptionsCount || $[27] !== onScroll || $[28] !== props) {
    t6 = filteredOptionsCount > 0 && <MultiSelectFilter {...props} showSelectAll={!props.hideSearch && !!filter} options={filteredOptions} onVirtuosoScroll={onScroll} showNameFirst={props.showNameFirst} shouldShowId={props.shouldShowId} />;
    $[24] = filter;
    $[25] = filteredOptions;
    $[26] = filteredOptionsCount;
    $[27] = onScroll;
    $[28] = props;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  let t7;
  if ($[30] !== onScroll || $[31] !== t5 || $[32] !== t6) {
    t7 = <Box className="overflow-auto px-[24px] py-[12px]" onScroll={onScroll} sx={t4}>{t5}{t6}</Box>;
    $[30] = onScroll;
    $[31] = t5;
    $[32] = t6;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  let t8;
  if ($[34] !== condition || $[35] !== props || $[36] !== selectedResources.length) {
    t8 = !!selectedResources.length && <Stack direction="row" className="px-[24px] py-[16px]" sx={{
      alignItems: "center",
      justifyContent: "space-between",
      boxShadow: "var(--mui-customShadows-panelUp)"
    }}><Typography>{`${selectedResources.length} ${props.entityName}s selected`}</Typography><Stack direction="row" sx={{
        alignItems: "center"
      }}><Tooltip title="Clear all"><IconButton onClick={() => props.onChange(props.conditions.filter(x_2 => x_2 !== condition))}><i className="material-symbols-filter-alt-off-outline-rounded text-(--mui-palette-text-primary) h-[20px] w-[20px]" /></IconButton></Tooltip><Button className="ml-[12px]" variant="outlined" onClick={() => props.onDoneClick()}>Done</Button></Stack></Stack>;
    $[34] = condition;
    $[35] = props;
    $[36] = selectedResources.length;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  let t9;
  if ($[38] !== t3 || $[39] !== t7 || $[40] !== t8) {
    t9 = <Stack className="h-full overflow-hidden">{t3}{t7}{t8}</Stack>;
    $[38] = t3;
    $[39] = t7;
    $[40] = t8;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  return t9;
};
function _temp(x) {
  return !x.isGroupTitle;
}
function _temp2(x_0) {
  return x_0.id;
}
function _temp3(x) {
  return x.property === backupStatus.name;
}
function _temp4(x_0) {
  return x_0.operator === ConditionOperatorEnum.In;
}
function _temp5(x_1) {
  return x_1.operator === ConditionOperatorEnum.NotIn;
}
function _temp6(x_2) {
  return x_2.property === controlLevel.name;
}
function _temp7(x_1) {
  return !x_1.isGroupTitle;
}